import React from 'react';
import moment from 'moment';
import { first } from 'lodash';

const FlagUserList = ({ flag, users = [] }) => {
  const userArray = users.filter(
    item => item.user_id === flag.audit.updated_by,
  );

  const user = userArray.length !== 0 ? first(userArray) : undefined;

  return (
    <tr>
      <td>
        {user ? (
          <React.Fragment>
            <p>{user.display_name} </p>
          </React.Fragment>
        ) : (
          flag.audit.updated_by
        )}
      </td>
      <td>{user && user.email}</td>
      <td>{moment(flag.audit.updated_at).format('lll')}</td>
      <td>{flag.flag_content}</td>
    </tr>
  );
};
export default FlagUserList;
